export const MarkerStyle = (width, height) => ({
    position: 'absolute',
    width: `${width}px`,
    height: `${height}px`,
    left: `-${width / 2}px`,
    top: `-${height}px`,
})

export const defaultStyle = MarkerStyle(50, 50)
